import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(routerState: RouterStateSnapshot): void {
    // Si la ruta marca skipTitle no realiza cambio
    if (this.hasSkipTitle(routerState.root)) return;

    const routeTitle = this.buildTitle(routerState);
    this.title.setTitle(routeTitle ? `${routeTitle} - ShareWave` : 'ShareWave');
  }

  private hasSkipTitle(route: ActivatedRouteSnapshot): boolean {
    if (route.data['skipTitle']) return true;
    return route.children.some((child) => this.hasSkipTitle(child));
  }
}
